import React from "react";
import ProductGroupGenericSkeleton from "./ProductGroupGenericSkeleton";

function ProductGroupDetailSkeleton() {
  return (
    <>
      <ProductGroupGenericSkeleton />
    </>
  );
}

export default ProductGroupDetailSkeleton;
